import { createTransform } from 'redux-persist';

import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pruneDeletedResources = createTransform<
  ReduxState['projects'],
  ProjectsState,
  ReduxState
>(
  (projectsState) => {
    const prunedProjectsById: Record<string, Project> = {};
    projectsState.projectIds.forEach((id) => {
      const project = projectsState.projectsById[id];
      const modelSnapshot = project.diagram?.model;

      if (!modelSnapshot) {
        prunedProjectsById[project.id] = { ...project };
        return;
      }

      const resourceIds = new Set(
        modelSnapshot.nodeDataArray
          .filter((nodeData) => isResource(nodeData))
          .map((nodeData) => nodeData.value)
      );

      const fileUploadsById = { ...project.fileUploadsById };
      Object.keys(fileUploadsById).forEach((fileUploadId) => {
        if (!resourceIds.has(fileUploadId)) {
          delete fileUploadsById[fileUploadId];
        }
      });

      const virtualGraphsById = { ...project.virtualGraphsById };
      Object.keys(virtualGraphsById).forEach((virtualGraphId) => {
        if (!resourceIds.has(virtualGraphId)) {
          delete virtualGraphsById[virtualGraphId];
        }
      });

      const newProject = { ...project, fileUploadsById, virtualGraphsById };
      prunedProjectsById[project.id] = newProject;
    });

    return { ...projectsState, projectsById: prunedProjectsById };
  },
  null,
  { whitelist: ['projects'] }
);
